import React, { useState } from 'react';
import { changePassword } from '../../auth';
import Button from '../../lib/button/Button';
import TextField from '../../lib/text-field/TextField';

const ChangePasswordForm: React.FC = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [oldPassword, setOldPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [showCurrentPassword, setShowCurrentPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);

	const handleChangePassword = async (
		oldPassword: string,
		newPassword: string
	) => {
		setIsSubmitting(true);
		await changePassword(oldPassword, newPassword);
		setIsSubmitting(false);
	};

	return (
		<form
			style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
			onSubmit={(e) => {
				e.preventDefault();
				handleChangePassword(oldPassword, newPassword);
			}}
		>
			<TextField
				iconEnd='fa-solid fa-eye'
				type={showCurrentPassword ? 'text' : 'password'}
				name='current-password'
				label='Current password'
				autocomplete='current-password'
				value={oldPassword}
				disabled={isSubmitting}
				onChange={(value: any) => setOldPassword(value)}
				onIconClick={() => setShowCurrentPassword(!showCurrentPassword)}
			/>
			<TextField
				iconEnd='fa-solid fa-eye'
				type={showNewPassword ? 'text' : 'password'}
				name='new-password'
				label='New password'
				autocomplete='new-password'
				value={newPassword}
				disabled={isSubmitting}
				onChange={(value: any) => setNewPassword(value)}
				onIconClick={() => setShowNewPassword(!showNewPassword)}
			/>
			<div style={{ marginBottom: '16px' }}>
				<Button
					variant='outlined'
					color='primary'
					size='small'
					type='submit'
					loading={isSubmitting}
				>
					Save
				</Button>
			</div>
		</form>
	);
};

export default ChangePasswordForm;
